var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap align-center mb-3"
            },
            [
              _c(
                "div",
                {
                  staticClass: "body-1 mr-auto"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pb-1",
                      attrs: {
                        size: "24",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-console-line")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ml-2"
                    },
                    [_vm._v("Terminal")]
                  )
                ],
                1
              ),
              _c(
                "v-chip",
                {
                  staticClass: "kvm-status",
                  class: "kvm-status--" + _vm.status,
                  attrs: {
                    small: "",
                    label: "",
                    role: "status",
                    "aria-live": "polite"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "kvm-sr-only"
                    },
                    [_vm._v("Terminal status: ")]
                  ),
                  _vm._v(_vm._s(_vm.statusChip.text) + " ")
                ]
              )
            ],
            1
          ),
          _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: {
                    type: "error",
                    border: "left",
                    dense: ""
                  }
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm._e(),
          _vm.server.power_state && _vm.server.power_state !== "online"
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-3",
                  attrs: {
                    type: "info",
                    border: "left",
                    dense: ""
                  }
                },
                [
                  _vm._v(
                    " This server is " +
                      _vm._s(_vm.server.power_state) +
                      ". The terminal will connect automatically once it is powered on. "
                  )
                ]
              )
            : _vm._e(),
          _c(
            "p",
            {
              staticClass: "kvm-caption text-caption mb-2",
              attrs: {
                id: "kvm-terminal-instructions"
              }
            },
            [
              _vm._v(
                " This is a live command-line shell on your server. Click or tab into the area below to type; output streams back in real time. "
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "vds-terminal-screen",
              style: {
                height: _vm.screenHeight + "px"
              },
              attrs: {
                role: "group",
                "aria-label": "Server terminal (serial console)",
                "aria-describedby": "kvm-terminal-instructions"
              },
              on: {
                click: _vm.focusTerminal
              }
            },
            [
              _c("div", {
                ref: "screen",
                staticClass: "vds-terminal-mount"
              }),
              _vm.status !== "connected"
                ? _c(
                    "div",
                    {
                      staticClass: "vds-terminal-placeholder",
                      attrs: {
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _vm.status === "connecting"
                        ? _c("v-progress-circular", {
                            staticClass: "mb-2",
                            attrs: {
                              indeterminate: "",
                              color: "primary"
                            }
                          })
                        : _vm._e(),
                      _c("div", [_vm._v(_vm._s(_vm.placeholderText))])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }